/** 현재 사이트 도메인 (site.url 매칭용) — 배포 후 실제 도메인으로 수정 필요 */
export const SITE_DOMAIN = "colortolifebiz.zipshowkorea.com";

/** 도메인 매칭 실패 시 기본 사이트 ID — 백엔드 site 테이블의 biz 사이트 ID로 수정 필요 */
export const DEFAULT_SITE_ID = 4;
